// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"dc7245af","149":"fb835a0c","328":"d68166ba","488":"e5febcbf","588":"4b064b5e","975":"1d677062"}[chunkId] + ".css";
};